import Popper from 'popper.js';

// Default class names for dropdown states
const CLASS_NAME = {
  DROPDOWN: 'dropdown',
  DROPDOWN_MENU: 'dropdown__menu',
  DROPDOWN_OPEN: 'dropdown--open'
};

// Default configs for popper
const CONFIG = {
  placement: 'bottom-end'
};

// Default dropdown selector
const DEFAULT_SELECTOR = '[data-toggle="dropdown"]';

export const DEFAULT_OPTIONS = {
  className: CLASS_NAME,
  config: CONFIG,
  selector: DEFAULT_SELECTOR
};

class Dropdown {
  /**
   * Initializer
   *
   * @param {Element} elementRef - HTML node, to add dropdown properties on.
   * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
   * */
  constructor(elementRef, options = DEFAULT_OPTIONS) {
    // Initialise attributes

    // Root dropdown container
    this.elementRef = elementRef;
    // Object to hold all the className of the modal
    this.className = options.className || CLASS_NAME;
    this.config = options.config || CONFIG;

    this._dropdown = this.elementRef.closest(`.${this.className['DROPDOWN']}`);
    this._dropdownMenu = this._dropdown.querySelector(`.${this.className['DROPDOWN_MENU']}`);

    this._popper = new Popper(this.elementRef, this._dropdownMenu, this.config);

    // Bind functions
    this.hide = this.hide.bind(this);
    this.toggle = this.toggle.bind(this);

    this._setup();
  }

  // Event Handlers

  /**
   * Event handler to toggle the dropdown.
   *
   * @param {Event} event - click event on the toggle button `this.elementRef`.
   * */
  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    this._dropdown.classList.toggle(`${this.className['DROPDOWN_OPEN']}`);
    this._popper.update();
  }

  /**
   * Event handler to hide the dropdown.
   *
   * @param {Event} event - click event
   * */
  hide(event) {
    this._dropdown.classList.remove(`${this.className['DROPDOWN_OPEN']}`);
  }

  // private

  /**
   * Set-up the dropdown.
   *  1) Appropriately binds all necessary event callbacks.
   * */
  _setup() {
    this._addEventListeners();
  }

  /**
   * Adds all the required event listeners.
   * */
  _addEventListeners() {
    this.elementRef.addEventListener('click', this.toggle);
    document.body.addEventListener('click', this.hide);
  }
}

export default Dropdown;
